import CanvasToImg from './components';

const VueCanvasToImg = function(Vue, config = {}) {
  if (VueCanvasToImg.installed) return;
  Vue.$bus =  Vue.prototype.$bus = new Vue()
  Vue.$preImages = Vue.prototype.$preImages = []

  Vue.component(CanvasToImg.name, CanvasToImg);

  Vue.$bus.$on("loadedImg",(el) => {
    var flag = false
    Vue.$preImages.filter((imgEl,i) => {
      if(el.name == imgEl.name) {
        Vue.$preImages[i] = el
        flag = true
      }
    })
    if(!flag) {
      Vue.$preImages.push(el)
    }
  })

  Vue.$preloadImg = Vue.prototype.$preloadImg = function(image) {
    if(localStorage.getItem('imgData')) {
      localStorage.removeItem('imgData')
    }
    let imgs = []
    if(typeof image === 'object' ) {
      imgs.push(image)
    }
    if(Array.isArray(image)){
      imgs = image
    }

    imgs.forEach((el) => {
        var img = new Image()
        img.crossOrigin = ''
        img.src = el.src
        img.onload = () => {
          loadStatusCheck.call(this)
        }

        function loadStatusCheck() {
          if(img.complete){
            el.img = img
            Vue.$bus.$emit('loadedImg',el)
          }else {
            setTimeout(() => {
              loadStatusCheck.call(this)
            },300)
          }
        }
    })

  }
};

// auto install
if (typeof window !== 'undefined' && window.Vue) {
  VueCanvasToImg(window.Vue);
};

export {VueCanvasToImg ,CanvasToImg}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-canvas-to-img/src/index.js
// module id = null
// module chunks = 